const chat = {
    en: {
        "chat.title": "Chat",
        "chat.conversations": "Conversations",
        "chat.noConversations": "No conversations",
        "chat.selectConversation": "Select a conversation",
        "chat.typeMessage": "Type a message…",
        "chat.send": "Send",
        "chat.you": "You",
        "chat.staff": "Support",
        "chat.empty": "No messages yet. Say hello!",
        "chat.withSupport": "Chat with support",
    },
    ru: {
        "chat.title": "Чат",
        "chat.conversations": "Беседы",
        "chat.noConversations": "Нет бесед",
        "chat.selectConversation": "Выберите беседу",
        "chat.typeMessage": "Введите сообщение…",
        "chat.send": "Отправить",
        "chat.you": "Вы",
        "chat.staff": "Поддержка",
        "chat.empty": "Сообщений пока нет. Напишите первым!",
        "chat.withSupport": "Чат с поддержкой",
    },
    geo: {
        "chat.title": "ჩატი",
        "chat.conversations": "მიმოწერები",
        "chat.noConversations": "მიმოწერები არ არის",
        "chat.selectConversation": "აირჩიეთ მიმოწერა",
        "chat.typeMessage": "დაწერეთ შეტყობინება…",
        "chat.send": "გაგზავნა",
        "chat.you": "თქვენ",
        "chat.staff": "მხარდაჭერა",
        "chat.empty": "შეტყობინებები ჯერ არ არის. მოგესალმებით!",
        "chat.withSupport": "ჩატი მხარდაჭერასთან",
    },
};

export default chat;
